const T = {
  // Backgrounds — dark throughout
  bgPage:    "#0f0f0f",
  bgSurface: "#111111",
  bgDeep:    "#141414",
  bgRaised:  "#1a1a1a",
  bgBorder:  "#222222",

  // Borders
  borderLight: "#1a1a1a",
  borderMed:   "#1e1e1e",

  // Text — all white/near-white for readability on dark backgrounds
  textPrimary:   "#FFFFFF",   // titles, headings, names, nav items
  textSecondary: "#FFFFFF",   // body text, descriptions, content
  textBody:      "#FFFFFF",   // standard body copy
  textSubtle:    "#DDDDDD",   // secondary labels
  textMuted:     "#BBBBBB",   // hints, placeholders, timestamps
  textDim:       "#999999",   // very quiet — dates, captions

  // Font sizes — use ONLY these, never hardcode px values.
  // Restored 2026-06-17 to the documented scale (body 20 / label 16); the scale
  // had drifted ~25% larger, which made Scout reports unreadable.
  // Bumped 2026-08-09 (Roger) to accessibility standards for OUTDOOR use by a 65-yo: readable content
  // is now >= 16px (WCAG body min); badges >= 14. Only FlipYard imports this theme, so this is safe.
  fontTiny:    14,   // badge labels, tiny indicators (was 12)
  fontXS:      16,   // captions, dates, secondary metadata (was 14; now meets 16px body standard)
  fontLabel:   18,   // form labels, small UI elements (was 16)
  fontSM:      20,   // small body text
  fontMD:      22,   // standard content text
  fontLG:      26,   // large body, notes, descriptions
  fontTitle:   28,   // card titles, status text
  fontHuge:    34,   // section headings
  fontDisplay: 44,   // display numbers, hero values
  fontHero:    72,   // decorative watermark only

  // Accent colors
  purple: "#a78bfa",
  blue:   "#4f8ef7",
  teal:   "#0e7490",
  red:    "#e84545",
  green:  "#22c55e",
  amber:  "#f59e0b",
  gold:   "#f59e0b",
  pink:   "#ec4899",

  // Primary accent (brand blue). `accent` is a bright fill (dark text sits on it, see ui.tsx);
  // `accentText` is the bright accent used for TEXT / active states on the dark background.
  accent:     "#4f8ef7",
  accentText: "#6ea8ff",

  // Font family — system stack.
  font: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",

  // Font weights — use these, never hardcode.
  wReg:   400,
  wMed:   500,
  wBold:  700,
  wHeavy: 800,

  // Spacing scale (4px base). Numbers; React appends px.
  s1: 4,
  s2: 8,
  s3: 12,
  s4: 16,
  s5: 20,
  s6: 24,
  s7: 32,
  s8: 40,

  // Corner radius.
  rSm:   8,
  rMd:   12,
  rLg:   16,
  rPill: 999,

  // Tap targets — large for gloved, outdoor, 65-yo use (WCAG min 48).
  tapMin:  48,
  tapMain: 56,
  tapHero: 72,

  // Card shadow.
  shadowCard: "0 1px 3px rgba(0,0,0,0.4)",
};
export default T;
